
/* Vue Apps */
require('./vue/dashboard.js');
require('./vue/customers.js');
require('./vue/datacleansing.js');
require('./vue/login.js');
require('./vue/queue.js');
require('./vue/monitor.js');
require('./vue/vouchers.js');
require('./vue/appmessages.js');
require('./vue/reporting.js');
require('./vue/users.js');
require('./vue/user.js');
require('./vue/segment-builder.js');
require('./vue/signup.js');
require('./vue/metrics.js');
require('./vue/client-menu.js');
